const basePath = '/personal/my-collection'
export const ROUTER_PERSONAL_MYCOLLECTION = {
	list: `${basePath}/exam`,
	detail: id => (id ? `${basePath}/exam/${id}` : `${basePath}/exam/:id`)
}

export const TRANSLATE_PERSONAL_MYCOLLECTION = `${basePath}`
